import reducer from './reducer';

export { default as boardActions } from './actions';
export { default as boardSelectors } from './selectors';

export default reducer;
